import React, { useState } from 'react';

function AppForm({props, targetProcess, person, setPerson}) {
    
    const handleChange = (e) => {
        const fieldName = e.target.name;
        const fieldValue = e.target.value;
        if( fieldName === 'photo' ){
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.addEventListener('load', ()=>{
                setPerson({
                    ...person,
                    [fieldName]: reader.result,
                });    
            });
        }else{
            setPerson({
                ...person,
                [fieldName]: fieldValue,
            });
        }
    };    

    const [counter, setCounter] = useState(0);
    const handelLocalStorage = (e, count, object) => {
        if( count === 8 ){ 
            console.log(object);  

            
            window.localStorage.setItem('person-photo', object['photo']);
            window.localStorage.setItem('person-name', object['name']);
            window.localStorage.setItem('person-age', object['age']);
            window.localStorage.setItem('person-email', object['email']);
            window.localStorage.setItem('person-phone', object['phone']);
            window.localStorage.setItem('person-title', object['title']);
            window.localStorage.setItem('person-position', object['position']);
            window.localStorage.setItem('person-skills', object['skills']);

            e.target.reset();             
            console.log(localStorage);
            window.location.replace('/#/PersonalCard');
        }
    }

    const handelSubmit = (e) => {
        e.preventDefault();

        const inputs = [...document.querySelectorAll('#app-form .app-form__item input') , document.querySelector('#app-form .app-form__item textarea')];

        for(let i = 0; i < inputs.length; i++){            
            if(inputs[i].value.length === 0){ inputs[i].nextElementSibling.style.display = 'block';    
            }else{ inputs[i].nextElementSibling.style.display = 'none'; }

            if( i === 1 && inputs[i].value.length > 0 ){
                if( inputs[i].value.length < 2 ){ inputs[i].nextElementSibling.textContent = 'name must larger 2 chars'; inputs[i].nextElementSibling.style.display = 'block';  }
                if( inputs[i].value.charCodeAt(0)  < 60 ){ inputs[i].nextElementSibling.textContent = 'name not start with number'; inputs[i].nextElementSibling.style.display = 'block';  }    
            }

            if(i === 2 && inputs[i].value.length > 0){
                if( inputs[i].value.length < 2  ){ inputs[i].nextElementSibling.textContent = 'Age must be at least one digit'; inputs[i].nextElementSibling.style.display = 'block';  }
                if( inputs[i].value.charAt(0) === '0' ){ inputs[i].nextElementSibling.textContent = 'first digit not allow to zero'; inputs[i].nextElementSibling.style.display = 'block'; }
                let phLn = 0;
                for(let j = 0; j< inputs[i].value.length; j++){
                    if( inputs[i].value.charCodeAt(j) >= 48 && inputs[i].value.charCodeAt(j) <= 57 ){
                        phLn += 1;
                    }
                }
                if( inputs[i].value.length !== phLn ){
                    inputs[i].nextElementSibling.textContent = 'chars now allow'; inputs[i].nextElementSibling.style.display = 'block';                    
                }    
            }

            if( i === 3 && inputs[i].value.length > 0 ){
                const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                // const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[(gmail)/(yahoo)]+(?:\.[(com)/(net)/(org)]+)*$/;
                if( inputs[i].value.length < 11 ){ inputs[i].nextElementSibling.textContent = 'email must 12 chars at least'; inputs[i].nextElementSibling.style.display = 'block';  }
                if( emailPattern.test(inputs[i].value) === false ){ inputs[i].nextElementSibling.textContent = 'email not valid'; inputs[i].nextElementSibling.style.display = 'block';   }
            }

            if(i === 4 && inputs[i].value.length > 0){
                if( inputs[i].value.length !== 11  ){ inputs[i].nextElementSibling.textContent = 'phone must 11 number'; inputs[i].nextElementSibling.style.display = 'block';  }
                if( inputs[i].value.charCodeAt(0) !== 48 ){ inputs[i].nextElementSibling.textContent = 'first number must zero'; inputs[i].nextElementSibling.style.display = 'block'; }
                if( inputs[i].value.charCodeAt(1) !== 49 ){ inputs[i].nextElementSibling.textContent = 'second number must one'; inputs[i].nextElementSibling.style.display = 'block'; }
                let phLn = 0;
                for(let j = 0; j< inputs[i].value.length; j++){
                    if( inputs[i].value.charCodeAt(j) >= 48 && inputs[i].value.charCodeAt(j) <= 57 ){
                        phLn += 1;
                    }
                }
                if( inputs[i].value.length !== phLn ){
                    inputs[i].nextElementSibling.textContent = 'chars now allow'; inputs[i].nextElementSibling.style.display = 'block';                    
                }    
            }

            if( i === 5 && inputs[i].value.length > 0 ){
                if( inputs[i].value.length <= 5 ){ inputs[i].nextElementSibling.textContent = 'title must larger 5 chars'; inputs[i].nextElementSibling.style.display = 'block';  }
                let phLn = 0;
                for(let j = 0; j< inputs[i].value.trim().length; j++){
                    if( inputs[i].value.trim().charCodeAt(j) < 48 || inputs[i].value.trim().charCodeAt(j) > 57 ){
                        phLn += 1;
                    }
                }
                if( inputs[i].value.length !== phLn ){
                    inputs[i].nextElementSibling.textContent = 'numbers now allow'; inputs[i].nextElementSibling.style.display = 'block';                    
                }    
            }

            if( i === 6 && inputs[i].value.length > 0 ){
                if( inputs[i].value.length <= 5 ){ inputs[i].nextElementSibling.textContent = 'position must larger 5 chars'; inputs[i].nextElementSibling.style.display = 'block';  }
                let phLn = 0;
                for(let j = 0; j< inputs[i].value.trim().length; j++){
                    if( inputs[i].value.trim().charCodeAt(j) < 48 || inputs[i].value.trim().charCodeAt(j) > 57 ){
                        phLn += 1;
                    }
                }
                if( inputs[i].value.trim().length !== phLn ){
                    inputs[i].nextElementSibling.textContent = 'numbers now allow'; inputs[i].nextElementSibling.style.display = 'block';                    
                }    
            }

            if( i === 7 && inputs[i].value.length > 0 ){
                const Skills = inputs[i].value.split(' ');
                if( Skills.length === 0 ){ inputs[i].nextElementSibling.textContent = 'Skills must be one at least'; inputs[i].nextElementSibling.style.display = 'block';  }
            }
        }
                
        const labels = [ ...document.querySelectorAll('#app-form .app-form__item div') ];
        for( let i = 0; i< labels.length; i++ ){
            if( i === 0 ){ setCounter(0); }
            if( labels[i].style.display === 'none' ){ setCounter( prevState => prevState + 1 );
            }else{ setCounter( prevState => prevState + 0 ); }
        }
    }


    const items = ['photo', 'name', 'age', 'email', 'phone', 'title', 'position', 'skills'],
        itemsTxt = ['photo', 'name', 'age', 'email', 'phone number', 'job title', 'current position', 'skills'];
    
    return (
        <section id='app-form'>
            {
                (targetProcess === 'edit') ?
                <h3> <img src={person.photo} alt='avatar'/> {person.name} Form </h3>
                : <h3>Person Form </h3>
            }
            <form action="" onSubmit={(e) => {
                handelSubmit(e);
                handelLocalStorage(e, counter, person);
            }}>
            { items.map((item, index) => { return(
                <div key={index} className="app-form__item">{
                    (index === 0) ? 
                    <>
                        <label>{`Insert ${itemsTxt[index]}`}</label>                                            
                        <input type="file" name={item} onChange={handleChange} />
                        <div> {`Please choose your ${itemsTxt[index]}`} </div>
                    </>
                    : (index === 7) ?
                    <>
                        <label htmlFor={`it${item}`}>{itemsTxt[index]}</label>            {/* value={person[`${item}`]}   value={localStorage.getItem(`person-${item}`)} */}                                
                        <textarea cols="15" rows="4" name={item} id={`it${item}`} placeholder={` type your ${itemsTxt[index]} after every skill 1 space : design photoshop`} value={person[`${item}`]} onChange={handleChange}></textarea>
                        <div> {`Please type your ${itemsTxt[index]}`} </div>
                    </>
                    :<>
                        <label htmlFor={`it${item}`}>{itemsTxt[index]}</label>                                            
                        <input type="text" name={item} id={`it${item}`} placeholder={` type your ${itemsTxt[index]}`} value={person[`${item}`]} onChange={handleChange}/>    
                        <div> {`Please type your ${itemsTxt[index]}`} </div>                            
                    </>
                }
                </div>                        
            ) } ) }
            {
                (targetProcess === 'edit') ?
                <button type="submit"> Update Card </button>
                : <button type="submit"> Make Card </button>
            }
            </form>
        </section>
    )
}

export default AppForm
